import { createAction, props } from '@ngrx/store';
import { IPendingInvitedTabBusinessManagementUsersRequest } from '../models/pending-invited-business-managment-users.model';
import { IPendingInvitedEmployeesQuickSearchResponse } from '../../../shared/models/shared.model';

export const loadAdministratorsPendingInvitedBusinessManagementUserQuickSearchs = createAction(
  '[AdministratorsPendingInvitedBusinessManagementUserQuickSearch] Load Administrators PendingInvitedBusinessManagementUserQuickSearchs',
  props<{
    businessId: string;
    userRoleIds: string[];
    request: IPendingInvitedTabBusinessManagementUsersRequest;
  }>()
);

export const loadAdministratorsPendingInvitedBusinessManagementUserQuickSearchsSuccess = createAction(
  '[AdministratorsPendingInvitedBusinessManagementUserQuickSearch] Load Administrators PendingInvitedBusinessManagementUserQuickSearchs Success',
  props<{ response: IPendingInvitedEmployeesQuickSearchResponse }>()
);

export const loadAdministratorsPendingInvitedBusinessManagementUserQuickSearchsFailure = createAction(
  '[AdministratorsPendingInvitedBusinessManagementUserQuickSearch] Load Administrators PendingInvitedBusinessManagementUserQuickSearchs Failure',
  props<{ error: Error | any }>()
);

export const clearAdministratorsPendingInvitedBusinessManagementUserQuickSearchs = createAction(
  '[AdministratorsPendingInvitedBusinessManagementUserQuickSearch] Clear Administrators PendingInvitedBusinessManagementUserQuickSearch'
);

export const isAdministratorsPendingInvitedFirstTimeLoad = createAction(
  '[AdministratorsPendingInvitedBusinessManagementUserQuickSearch First Time Loaded] Administrators isAdministratorsPendingInvitedFirstTimeLoad',
  props<{ firstTimeLoad: boolean }>()
);
